import { ChartCard, usePal } from "./StatsCharts";
import { bucketLabel } from "./statsUtils";

const shade = (v, dark) => {
  const [a, b] = dark ? ["#15233A", "#1F2E45"] : ["#F3F4F6", "#E5E7EB"];
  if (v == null) return `repeating-linear-gradient(45deg,${a},${a} 3px,${b} 3px,${b} 6px)`;
  if (v === 0) return a;
  return `rgba(17,162,133,${0.18 + (Math.min(v, 100) / 100) * 0.82})`;
};

export function OccupancyHeatmap({ heatmap, gran }) {
  const { dark } = usePal();
  const { keys, rows } = heatmap;
  const cell = gran === "day" ? 22 : 34;
  return (
    <ChartCard title="Toplinska karta zauzeća" subtitle={gran === "day" ? "Jedinica × dan (tamnije = zauzeto)" : `Jedinica × ${gran === "week" ? "tjedan" : "mjesec"} (% zauzeća)`} testId="stats-heatmap">
      <div className="overflow-x-auto">
        <table className="border-separate" style={{ borderSpacing: 2 }}>
          <thead>
            <tr>
              <th className="sticky left-0 z-10 bg-card" />
              {keys.map((k) => (
                <th key={k} className="whitespace-nowrap px-0 pb-1 text-[9px] font-medium text-muted-foreground" style={{ minWidth: cell }}>
                  {bucketLabel(k, gran)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.unit_id} data-testid={`stats-heat-row-${r.unit_id}`}>
                <td className="sticky left-0 z-10 max-w-[96px] truncate bg-card pr-2 text-[11px] font-medium text-foreground">{r.name}</td>
                {r.values.map((v, i) => (
                  <td key={keys[i]} title={`${r.name} · ${bucketLabel(keys[i], gran)} · ${v == null ? "blokirano" : `${v}%`}`} className="rounded-[4px] p-0 transition-transform duration-150 hover:scale-110" style={{ width: cell, height: 20, background: shade(v, dark) }} />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-3 flex items-center gap-3 text-[10px] text-muted-foreground">
        <span className="inline-flex items-center gap-1"><span className="h-3 w-3 rounded" style={{ background: shade(0, dark) }} /> slobodno</span>
        <span className="inline-flex items-center gap-1"><span className="h-3 w-3 rounded" style={{ background: shade(50, dark) }} /> djelomično</span>
        <span className="inline-flex items-center gap-1"><span className="h-3 w-3 rounded" style={{ background: shade(100, dark) }} /> zauzeto</span>
        <span className="inline-flex items-center gap-1"><span className="h-3 w-3 rounded" style={{ background: shade(null, dark) }} /> blokirano</span>
      </div>
    </ChartCard>
  );
}
